<section class="case-tracker-tab-cont">
  @if (reg60TrackerData().length) {
    <ent-tabs>
      <tab>
        <tab-title class="tab-title_case"><span>Case</span></tab-title>
        <tab-content>
          <ng-container *ngTemplateOutlet="caseTracker"></ng-container>
        </tab-content>
      </tab>
      @for (reg60Tracker of reg60TrackerData(); track reg60Tracker) {
        <tab>
          <tab-title class="tab-title_reg60"><span>REG60<br/>#{{ reg60Tracker.Reg60Number }}</span></tab-title>
          <tab-content>
            <app-case-tracker trackerType="reg60">
              @if (reg60Tracker.Required) {
                <span class="screen-reader-only">tracker with {{ reg60Tracker.TrackerSteps.length }} chevrons</span>
                @for (trackerStep of reg60Tracker.TrackerSteps; track trackerStep) {
                  <app-tracker-step class="tracker"
                    [step]="trackerStep"
                    [mobileView]="mobileView()">
                  </app-tracker-step>
                }
              }
              @if (!reg60Tracker.Required) {
                <ent-alert-message style="flex:1" type="info">{{ message.reg60NotRequired }}</ent-alert-message>
              }
            </app-case-tracker>
          </tab-content>
        </tab>
      }
    </ent-tabs>
  } @else {
    <ng-container *ngTemplateOutlet="caseTracker"></ng-container>
  }

  <ng-template #caseTracker>
    @if (contractData(); as contractData) {
      @if (contractTrackerData().length > 0) {
        <app-case-tracker [noLOA]="noLOA()" trackerType="case">
          <span class="screen-reader-only">tracker with {{ contractTrackerData().length }} chevrons</span>
          @for (trackerStep of contractTrackerData(); track trackerStep) {
            <app-tracker-step class="tracker"
              [step]="trackerStep"
              [SourceOfFundsUI]="contractData.SourceOfFundsUI"
              [FundsReceivedMoneyIn]="contractData.FundsReceivedMoneyIn"
              [notNoLOA]="notNoLOA()"
              [mobileView]="mobileView()">
            </app-tracker-step>
          }
        </app-case-tracker>
      }
    }
  </ng-template>
</section>
